<div class="w-100 p-3">
    <div>
        <div class="row my-3">
            <div class="col-7">
                <h3>Attributi Template</h3>
            </div>
        </div>
    </div>

    <div class="table-responsive">
        <table class="table detail-box">
            <tbody>
                <tr *ngFor="let field of fieldList">
                    <th scope="row">
                        {{field.external_name}} <span *ngIf="field.mandatory" ngbTooltip="Required">*</span>
                    </th>

                    <!-- 4 types considered as stated in documentation (string, number, date, enumerator) -->
                    <td>
                        <div *ngIf="field.type == 'enumerator'">
                            <select 
                                [class]="{ 'field-invalid': !formFields[field.name].valid }"
                                class="custom-select" 
                                [id]="field.name" 
                                [(ngModel)]="formFields[field.name].model"
                                (change)="validateForm()"
                            > 
                                <option *ngFor="let selectElement of enumerators[field.enumerator]" [value]="selectElement">{{selectElement}}</option>
                            </select>
                        </div>

                        <div *ngIf="field.type == 'string'">
                            <input 
                                [class]="{ 'field-invalid': !formFields[field.name].valid }"
                                type="text" 
                                [(ngModel)]="formFields[field.name].model" 
                                class="form-control" 
                                [id]="field.name" 
                                [placeholder]="field.external_name"
                                (input)="validateForm()"
                            >
                        </div>

                        <div *ngIf="field.type == 'number'">
                            <input 
                                [class]="{ 'field-invalid': !formFields[field.name].valid }"
                                type="number" 
                                [(ngModel)]="formFields[field.name].model" 
                                class="form-control" 
                                [id]="field.name" 
                                [placeholder]="field.external_name"
                                (input)="validateForm()"
                            >
                        </div>

                        <div *ngIf="field.type == 'date'">
                            <input 
                                [class]="{ 'field-invalid': !formFields[field.name].valid }"
                                type="date" 
                                [(ngModel)]="formFields[field.name].model" 
                                class="form-control" 
                                [id]="field.name" 
                                [placeholder]="field.external_name"
                                (input)="validateForm()"
                            >
                        </div>      
                        
                        <div *ngIf="field.type != 'enumerator' && field.type != 'string' && field.type != 'date' && field.type != 'number'">
                            <input  
                                [class]="{ 'field-invalid': !formFields[field.name].valid }"
                                type="text" 
                                [(ngModel)]="formFields[field.name].model" 
                                class="form-control" 
                                [id]="field.name" 
                                [placeholder]="field.external_name"
                                (input)="validateForm()"
                            >
                        </div>
                        
                        
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <button 
        class="btn btn-salva btn-block" 
        (click)="salvaTemplate()"
    >Salva</button>
</div>